window.onclick = function(event) {
  if (event.target.className === 'modal') {
    event.target.style.display = 'none';
  }
};
(function($) {
  $(function() {
    $('#accordionBtn').on('click', function() {
      $(this).next().slideToggle();
    });
  });
  const resizeWindow = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      const modalBtns = $('.modal-toggle');
      modalBtns.on('click', function() {
        const target = $(this).data('modal');
        const modal = document.getElementById(target);
        $(modal).slideDown(500, function() {
          const $logo = $(this).find('.modal-logo');
          setTimeout(function() {
            $logo.css('background-color', '#f3f4f0');
          }, 100);
        });
      });
      const closeBtns = $('.modal-close');
      closeBtns.on('click', function() {
        const modal = $(this).parents('.modal');
        modal.slideUp(500, function() {
          $(this).find('.modal-logo').css('background-color', '');
        });
      });
    } else {
      const modalBtns = document.querySelectorAll('.modal-toggle');
      modalBtns.forEach(function(btn) {
        btn.onclick = function() {
          var modal = btn.getAttribute('data-modal');
          document.getElementById(modal).style.display = 'block';
        };
      });
      const closeBtns = document.querySelectorAll('.modal-close');
      closeBtns.forEach(function(btn) {
        btn.onclick = function() {
          var modal = btn.closest('.modal');
          modal.style.display = 'none';
        };
      });
    }
  };

  resizeWindow();

  $(window).resize(function() {
    resizeWindow();
  });
})(jQuery);